/**
 * Migration source values that expected to be sent/received from migration-orchestrator backend (except 'ALL' value)
 */
export enum MigrationSource {
	ALL = 'ALL', // All migration sources below. This value is not supported by the backend.
	// So 'ALL' value should not be sent or received to backend and used withing frontend only.
	NETFIRM = 'NETFIRM',
	ULTRATAX = 'ULTRATAX',
	FILECABINET = 'FILECABINET',
	PRACTICECS = 'PRACTICECS',
	ACCOUNTINGCS = 'ACCOUNTINGCS',
	TAXCOMPETITOR = 'TAXCOMPETITOR'
}
